import React, { useState } from "react"
import PlayButton from "../../../assets/images/icons/play-button.svg"

import { Card, CardBody } from "reactstrap"
import Breadcrumb from "components/Common/Breadcrumb"
import VideoModal from "modals/videoModal"

const InvestmentVideoSearch = ({ data }) => {
  const [openVideo, setOpenVideo] = useState(false)
  const [video, setVideo] = useState("")

  return (
    <>
      <Card>
        <div className="page-search-title">
          <Breadcrumb title={data.title} />
        </div>
        <CardBody>
          <div className="playlist-wrapper-section mt-5">
            {data?.data.map((item, index) => (
              <div key={`video_${index}`} className="playlist-card-box">
                <div className="discover-icd-slider">
                  <img
                    width={"100%"}
                    src={item.thumbnail_url || posterImage}
                    alt=""
                  />
                  <div
                    onClick={() => {
                      setVideo(item)
                      setOpenVideo(true)
                    }}
                    className="play-icon"
                  >
                    <img src={PlayButton} alt="" />
                  </div>
                </div>
                <p>{item.title}</p>
              </div>
            ))}
          </div>
        </CardBody>
      </Card>
      {openVideo && (
        <VideoModal item={video} open={openVideo} setOpen={setOpenVideo} />
      )}
    </>
  )
}

export default InvestmentVideoSearch
